import { render, staticRenderFns } from "./recoveryFile.vue?vue&type=template&id=0cda2835&scoped=true"
import script from "./recoveryFile.vue?vue&type=script&lang=js"
export * from "./recoveryFile.vue?vue&type=script&lang=js"
import style0 from "./recoveryFile.vue?vue&type=style&index=0&id=0cda2835&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda2835",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cda2835')) {
      api.createRecord('0cda2835', component.options)
    } else {
      api.reload('0cda2835', component.options)
    }
    module.hot.accept("./recoveryFile.vue?vue&type=template&id=0cda2835&scoped=true", function () {
      api.rerender('0cda2835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/layout/recoveryFile.vue"
export default component.exports